/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Metadata_DescriptionInputs */

const en_common_metadata_description = /** @type {(inputs: Common_Metadata_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Independent game tools and guides`)
};

const zh_common_metadata_description = /** @type {(inputs: Common_Metadata_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`独立游戏工具与攻略`)
};

/**
* | output |
* | --- |
* | "Independent game tools and guides" |
*
* @param {Common_Metadata_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_metadata_description = /** @type {((inputs?: Common_Metadata_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Metadata_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_metadata_description(inputs)
	return zh_common_metadata_description(inputs)
});
export { common_metadata_description as "common.metadata.description" }